import {
  Container,
  FormControl,
  makeStyles,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { darkGreen, primaryColor } from 'src/data/colors';

interface StylesProps {
  isSmallScreen: boolean;
}

const useStyles = makeStyles<Theme, StylesProps>(() => ({
  container: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 'unset',
    padding: '40px 0 0',
  },
  row: {
    alignItems: (props: StylesProps) => (props.isSmallScreen ? '' : 'center'),
    display: 'flex',
    flexDirection: (props: StylesProps) => (props.isSmallScreen ? 'column' : 'row'),
    margin: '0 0 20px',
    width: '100%',
  },
  button: {
    background: primaryColor,
    marginTop: 20,
    width: 'fit-content',
    '&:hover': {
      background: darkGreen,
    },
  },
  label: {
    width: '150px',
  },
}));

const Selector = ({
  children,
  disabled,
  getOptionLabel,
  id,
  label,
  onChange,
  options,
  value,
}: {
  children?: React.ReactNode;
  disabled?: boolean;
  getOptionLabel?: (option: string) => string;
  id: string;
  label: string;
  onChange: (event: unknown, value: string | null) => void;
  options: string[];
  value: string | null;
}) => {
  const theme = useTheme();
  const isSmallPortrait = useMediaQuery(
    `${theme.breakpoints.down('xs')} and (orientation: portrait)`
  );
  const isSmallLandscape = useMediaQuery(
    `${theme.breakpoints.down('sm')} and (orientation: landscape)`
  );

  const isSmallScreen = isSmallPortrait || isSmallLandscape;
  const classes = useStyles({ isSmallScreen });

  return (
    <Container className={classes.row}>
      <Typography className={classes.label}>{label}</Typography>
      <FormControl>
        <Autocomplete
          disabled={disabled}
          getOptionLabel={getOptionLabel}
          id={id}
          onChange={onChange}
          options={options}
          renderInput={(params) => <TextField {...params} />}
          style={{ margin: '0 20px', width: '500px' }}
          value={value}
        />
      </FormControl>
      {children}
    </Container>
  );
};

export default Selector;
